import script from "./ChiSiamo.vue?vue&type=script&setup=true&lang=js"
export * from "./ChiSiamo.vue?vue&type=script&setup=true&lang=js"

import "./ChiSiamo.vue?vue&type=style&index=0&id=0ddd190d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddd190d"]])

export default __exports__